<template>
  <hm-content title="">
    <div class="table-panel flex flex-end item-center">
      <div>
        <el-date-picker
          clearable
          :default-time="['00:00:00', '23:59:59']"
          v-model="searchCondition.createTimeArry"
          type="datetimerange"
          align="right"
          start-placeholder="请选择开始时间"
          end-placeholder="请选择结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          class="mr10"
        ></el-date-picker>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="output('queryAllList', '复购订单计划详细')"
          >导出</el-button
        >
      </div>
    </div>
    <div>
      <el-table
        stripe
        ref="table"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="payTime"
          label="下单时间"
          width="250"
        >
          <template slot-scope="scope">
            <div class="flex item-center">
              {{ scope.row.payTime }}
              <el-tag type="" effect="plain" class="ml10" size="small"
                >{{
                  scope.row.orderTag === "repurchaseOrder"
                    ? "复购订单"
                    : "新客户订单"
                }}
              </el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardNo"
          label="会员卡号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberMobile"
          label="会员手机号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberName"
          label="客户姓名"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="receiptSn"
          label="订单号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="操作"
          width="200"
        >
          <template slot-scope="scope">
            <el-button
              size="small"
              class="blue"
              type="text"
              @click="viewOrder(scope.row)"
              >查看订单明细</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="订单详情"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="1000px"
    >
      <el-scrollbar :vertical="false" wrap-style="height: 500px;">
        <div class="mb20">
          <span class="mr20">会员：{{ currentRow.memberName }}</span>
          消费：<span class="primary">￥{{ currentRow.payPrice }}</span>
        </div>
        <div class="dialog-body">
          <div class="mb20">
            <div class="table-panel title">商品信息</div>
            <div class="table">
              <el-table
                stripe
                border
                :data="orderDetail"
                style="width: 100%"
                id="table"
                size="small"
              >
                <el-table-column
                  header-align="center"
                  prop="spu_name"
                  align="center"
                  label="商品名"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="市场价"
                >
                  <template slot-scope="scope">
                    <span class="primary">￥{{ scope.row.market_price }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="门店价"
                >
                  <template slot-scope="scope">
                    <span class="primary">￥{{ scope.row.shop_price }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  prop="goods_number"
                  align="center"
                  label="商品数量"
                ></el-table-column>
              </el-table>
            </div>
          </div>
          <div v-if="couponInfo.length">
            <div class="table-panel title">购买后已发放优惠券</div>
            <div class="table">
              <el-table
                stripe
                border
                :data="couponInfo"
                style="width: 100%"
                id="table"
                size="small"
              >
                <el-table-column
                  header-align="center"
                  prop="name"
                  align="center"
                  label="优惠券名"
                />
                <el-table-column
                  header-align="center"
                  prop="sendName"
                  align="center"
                  label="发放规则名"
                />
                <el-table-column
                  header-align="center"
                  prop="toOrder"
                  align="center"
                  label="已使用订单号"
                />
                <el-table-column
                  header-align="center"
                  prop="couponCode"
                  align="center"
                  label="优惠券码"
                />
                <el-table-column
                  header-align="center"
                  align="center"
                  label="优惠券状态"
                >
                  <template slot-scope="scope">
                    <span class="primary" v-if="scope.row.couponStatus === 2"
                      >已使用</span
                    >
                    <span class="primary" v-if="scope.row.couponStatus === 4"
                      >未使用</span
                    >
                    <span class="primary" v-if="scope.row.couponStatus === 5"
                      >冻结</span
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </el-scrollbar>
      <span slot="footer" class="dialog-footer flex flex-center">
        <!-- <el-button @click="sendCoupon(currentRow)" size="small" type="primary"
          >发券</el-button
        > -->
        <el-button @click="dialogVisible = false" size="small">关闭</el-button>
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      currentRow: {},
      couponInfo: [],
      orderDetail: [],
      dialogVisible: false,
      total: 0,
      list: [],
      pageSize: 10,
      currentPage: 1,
      searchCondition: {
        createTimeArry: []
      },
      type: this.$route.query.type
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    if (this.type === "today") {
      this.searchCondition.createTimeArry = [
        moment(new Date()).format("YYYY-MM-DD") + " 00:00:00",
        moment(new Date()).format("YYYY-MM-DD") + " 23:59:59"
      ];
    } else if (this.type === "yesterday") {
      this.searchCondition.createTimeArry = [
        moment(new Date())
          .add(-1, "days")
          .format("YYYY-MM-DD") + " 00:00:00",
        moment(new Date())
          .add(-1, "days")
          .format("YYYY-MM-DD") + " 23:59:59"
      ];
    }
    this.queryList();
  },
  methods: {
    async viewOrder(row) {
      const { result } = await this.$store.dispatch(
        "queryOfflineOrderDetails",
        {
          orderId: row.receiptSn,
          orderOfflineId: row.orderOfflineId
        }
      );
      const { couponInfo, orderDetail } = result;
      this.couponInfo = couponInfo;
      this.orderDetail = orderDetail;
      this.currentRow = row;
      this.dialogVisible = true;
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    data(row) {
      this.$router.push({
        name: "PlanningData",
        query: {
          row: JSON.stringify(row)
        }
      });
    },
    add() {
      this.$router.push({
        name: "SetMessagesPush"
      });
    },
    del(row) {
      this.$confirm("是否确认删除?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning"
      }).then(() => {
        console.log("row: ", row);
        // row.operateType = "del";
        // this.$store.dispatch("operateStoreRepurchasePlan", row).then(res => {
        //   if (res.code === "0") {
        //     this.$message({
        //       message: " 操作成功",
        //       type: "success"
        //     });
        //     this.queryList();
        //   }
        // });
      });
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.queryStartTime = this.isArray(
        this.searchCondition.createTimeArry
      )
        ? searchCondition.createTimeArry[0]
        : "";
      searchCondition.queryEndTime = this.isArray(
        this.searchCondition.createTimeArry
      )
        ? searchCondition.createTimeArry[1]
        : "";
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "queryRepurchaseOrderList",
        params
      );
      if (code === "0") {
        const { total, records } = result;
        this.list = records;
        this.total = total;
      }
    },
    async queryAllList() {
      const params = {
        pageSize: 99999,
        pageNo: 1
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.queryStartTime = this.isArray(
        this.searchCondition.createTimeArry
      )
        ? searchCondition.createTimeArry[0]
        : "";
      searchCondition.queryEndTime = this.isArray(
        this.searchCondition.createTimeArry
      )
        ? searchCondition.createTimeArry[1]
        : "";
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "queryAllRepurchaseOrderList",
        params
      );
      if (code === "0") {
        const { records } = result;
        return records;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    // 导出excel
    output(funcName, title) {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        const func = this[funcName];
        func()
          .then(res => {
            const list = res;
            list.forEach(v => {
              v.payTime = v.payTime + "(新客户订单)";
            });
            const tHeader = this.$refs.table.columns
              .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
              .filter(o => o);
            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs.table.$children
                .map(o => o._props.prop)
                .filter(o => o);
            }
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              title + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>
<style lang="scss" scoped></style>
